<div class="command-row">
  <!-- Con respuesta: el monitor pinta titulo + iconos arriba y respuestas centradas abajo -->
  <app-monitor-alert
    *ngIf="feederAnswered; else pending"
    [alert]="alert"
    [feeder]="feeder"
    [timezone]="timezone"
    [stacked]="true"
    (individualFeeder)="onRetry()"
  >
    <div monitorActions class="command-row__icons">
      <ng-container *ngTemplateOutlet="icons"></ng-container>
    </div>
  </app-monitor-alert>

  <!-- Sin respuesta: misma estructura que el monitor (titulo + iconos arriba,
       estado en su propia fila abajo, centrado) -->
  <ng-template #pending>
    <div class="command-row__head">
      <button
        *ngIf="feederFailed"
        type="button"
        class="command-row__retry"
        (click)="onRetry($event)"
        [title]="'testing.resend-ration' | translate"
      >
        <app-image-color
          [height]="'18px'"
          [width]="'18px'"
          [url]="'img/icons/reinicio-blanco.svg'"
          [color]="'#999999'"
        ></app-image-color>
      </button>
      <h4 class="m-0 command-row__title">{{ labelKey | translate }}</h4>

      <div class="command-row__icons">
        <ng-container *ngTemplateOutlet="icons"></ng-container>
      </div>
    </div>

    <div class="command-row__result" *ngIf="feederFailed">
      <span class="command-row__state is-error">
        <ng-container *ngIf="attempts > 0; else genericFailure">
          {{ "panel-alerts.no-response-attempts" | translate: { attempts: attempts } }}
        </ng-container>
        <ng-template #genericFailure> {{ "testing.command-failed" | translate }} </ng-template>
      </span>
    </div>

    <div class="command-row__loading" *ngIf="!feederFailed">
      <span class="spinner-border spinner-menu" role="status"></span>
      <span>{{ "testing.command-waiting" | translate }}</span>
    </div>
  </ng-template>
</div>

<!-- Iconos de respuesta del servidor (nube) y del alimentador (senal) -->
<ng-template #icons>
  <span
    class="command-row__icon"
    [class.is-ok]="serverOk"
    [class.is-error]="!serverOk"
    placement="left"
    container="body"
    [ngbPopover]="cloudInfo"
    triggers="mouseenter:mouseleave"
  >
    <app-image-color
      [url]="'img/icons/cloud.svg'"
      [color]="serverOk ? '#009e0f' : '#cf2a27'"
      [height]="'16px'"
      [width]="'20px'"
    ></app-image-color>
  </span>

  <ng-template #cloudInfo>
    <div *ngIf="alert && alert.data">
      <p class="m-0" *ngIf="alert.data.mac">Mac: {{ alert.data.mac }}</p>
      <p class="m-0" *ngIf="alert.data.lat != null">Lat: {{ alert.data.lat }}</p>
      <p class="m-0" *ngIf="alert.data.lng != null">Lng: {{ alert.data.lng }}</p>
      <p class="m-0" *ngIf="alert.data.version != null && !alert.data.hasOwnProperty('emptied')">
        {{ "tables.version" | translate }}: {{ alert.data.version }}
      </p>
    </div>
    <p class="m-0" *ngIf="!alert || !alert.data">{{ "testing.server-response" | translate }}</p>
  </ng-template>

  <span
    class="command-row__icon"
    [class.is-ok]="feederAnswered"
    [class.is-error]="feederFailed"
    placement="left"
    container="body"
    [ngbTooltip]="'testing.feeders-response' | translate"
  >
    <app-image-color
      [url]="'img/icons/senal-blanco.svg'"
      [color]="feederAnswered ? '#009e0f' : feederFailed ? '#cf2a27' : '#999999'"
      [height]="'16px'"
      [width]="'16px'"
    ></app-image-color>
  </span>
</ng-template>
